var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"ml-1 text-uppercase font-weight-bold caption"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }